/** steps: [{ amount, label, icon }] from donation-project frontmatter (§5.5). */
export default function StepIndicator({ steps, raised }) {
  return (
    <ol style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "2px", padding: 0, margin: 0 }}>
      {steps.map((step) => {
        const done = raised >= step.amount;
        return (
          <li
            key={step.amount}
            aria-current={done ? "step" : undefined}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "14px 16px",
              borderRadius: "8px",
              background: done ? "rgba(206,149,50,0.12)" : "transparent",
              fontSize: "14px",
              color: done ? "var(--color-cream)" : "var(--color-cream-soft)",
            }}
          >
            <span aria-hidden="true">{step.icon}</span>
            <span style={{ flex: 1 }}>{step.label}</span>
            <span style={{ fontFamily: "var(--font-mono)", fontSize: "12px" }}>{step.amount} €</span>
            {done && <span aria-hidden="true" style={{ color: "var(--color-gold)" }}>✓</span>}
          </li>
        );
      })}
    </ol>
  );
}
